<template>
  <div class="wrap">
    <div class="card-wrap">
      <div class="banner">
      </div>
      <a-card hoverable class="product-card">
        <div style="display:flex;align-items: center">
          <img :alt="name" :src="'/static/img/logo.png'" width="50px"/>
          <span class="title">解决方案</span>
        </div>
        <div class="content">
          <div class="solve-img">
            <img src="/static/img/jjfa1.png" width="30%" alt="解决方案">
            <img src="/static/img/jjfa2.png" width="30%" alt="解决方案">
          </div>
        </div>
      </a-card>
      <a-card v-for="(e, i) in subject" :key="i" class="product-card">
        <h1 slot="title">{{e.title}}</h1>
        <img :alt="e.title" :src="e.img" width="100%" slot="cover"/>
        <div class="text-content">
          {{e.content}}
        </div>
      </a-card>
    </div>
  </div>
</template>

<script>
import appConf from "@/config/config";
const { name } = appConf;

export default {
  name: "Solution",
  data() {
    return {
      name,
      subject: [
        {
          title: '焊接组装调试',
          img: '/static/img/hjzzts.png',
          content: `焊接厂位于昌平区横桥两岸共赢科技产业园总占面积1500平方米，于2013年开始承接各行业电路板焊接，加工的产品涉及电脑主板及板卡、数码产品、仪器仪表、通讯设备与终端网络产品、控制产品、光电产品、家用电子、汽车电子等众多电子产品领域。
    现有专业工程技术人员8人，专职质量保证（QA）人员2人，员工30多人，依据IPC-A-610D及公司标准，为产品质量提供了可靠的保证，公司配备了全新SMT贴片生产线、手工焊接线、组装线。设备仪器配置高性能稳定，可充分满足批量生产和研发试制生产。
    专业硬件工程师负责PCB板通电测试、程序写入、用工装进行调试等。并对客户产品资料保密。`
        },
        {
          title: '产品研发',
          img: '/static/img/cpyf.png',
          content: `6位从事软硬电路设计多年的工程师，主要针对研发能力弱的生产企业，根据企业需求对现有产品改进或新产品研发，其特点是为企业节省人工成本、沟通成本、更高效的出新品。`
        }
      ]
    };
  },
};
</script>
<style lang="css" scoped>
.title {
  font-size: 36px;
  margin-left: 2px;
}
.card-wrap {
  width: 100%;
  margin-bottom: 80px;
  display: flex;  
  flex-flow: column wrap;
  align-items: center;
  min-height: 100vh;
  overflow: hidden;
}
.banner {
  width: 100%;
  height: 500px;
  overflow: hidden;
  background: #fafdff url("/static/img/jjfa.jpg") no-repeat center center;
  background-size: cover;
}
.card-wrap .product-card {
  min-width: 300px;
  max-width: 1300px;
  width: 80%;
  margin: 20px;
  background-color: rgba(255, 255, 255, 0.75);
}
.content {
  padding: 20px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  min-height: 300px;
}
.solve-img {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.text-content {
  font-size: 18px;
}
@media screen and (max-width: 666px) {
  .title {
    font-size: 26px;
  }
  .banner {
    max-height: 300px;
  }
  .card-wrap {
    padding: 0;
    margin: 0 auto;
  }
  .card-wrap .product-card {
    width: 100%;
    margin: 0px;
  }
}
</style>
